import axios from "axios";

const BASE_URL = "https://api.ubikalo.app/";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getHomeData = async (id_perfil = 0) => {
  const timestamp = new Date().getTime();
  const response = await api.get(`home?id_perfil=${id_perfil}&_=${timestamp}`);
  return response.data;
};

function obtenerAnonId() {
  try {
    var key = "ubk_anon_id";
    var v = localStorage.getItem(key);
    if (v && v.length > 0) return v;
    var nuevo = "anon_" + Date.now() + "_" + Math.floor(Math.random() * 1000000);
    localStorage.setItem(key, nuevo);
    return nuevo;
  } catch (e) {
    return null;
  }
}

function detectarPlataforma() {
  try {
    var ua = navigator.userAgent || "";
    var isAndroid = ua.toLowerCase().indexOf("android") !== -1;
    var isIOS = /iPad|iPhone|iPod/.test(ua);
    if (isAndroid) return "android";
    if (isIOS) return "ios";
    return "web";
  } catch (e) {
    return "web";
  }
}

export const enviarLeadNegocio = async ({ nombre_persona, nombre_comercio, telefono, mensaje }) => 
  api.post("leads/negocio", { nombre_persona, nombre_comercio, telefono, mensaje });

export const registrarTapEvento = async (id_evento, opts = {}) => {
  try {
    let idPerfil = null;
    const stored = localStorage.getItem("id_perfil");
    if (stored) {
      idPerfil = parseInt(stored);
      if (isNaN(idPerfil)) idPerfil = null;
    }

    const payload = {
      id_evento: id_evento,
      id_perfil: opts.id_perfil || idPerfil,
      anon_id: opts.anon_id || obtenerAnonId(),
      plataforma: opts.plataforma || detectarPlataforma(),
      referrer: opts.referrer || document.referrer || null,
    };

    await api.post("eventos/tap", payload);
    return true;
  } catch (error) {
    console.error("❌ Error registrando tap evento:", error);
    return false;
  }
};

export const getHistorialPagos = async (id_perfil) => {
  try {
    const res = await api.get(`pagos/${id_perfil}`);
    return res.data.historial;
  } catch (error) {
    return [];
  }
};

export const getSeguidos = async (id_perfil) => {
  const response = await api.get(`seguidos/${id_perfil}`);
  return response.data;
};

export const loginConGoogle = async (google_id, correo, nombre, foto, anon_id) => {
  const response = await api.post("login/google", {
    google_id,
    correo,
    nombre,
    foto,
    anon_id
  });
  return response.data;
};

export const vincularGoogle = async (id_perfil, google_id, correo, foto) => {
  const response = await api.post("perfil/vincular-google", {
    id_perfil, google_id, correo, foto
  });
  return response.data;
};

export const desvincularGoogle = async (id_perfil) => {
  const response = await api.post("perfil/desvincular-google", { id_perfil });
  return response.data;
};

export const getReferidos = async (id_perfil) => {
  try {
    const res = await fetch(`${BASE_URL}referidos`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_perfil }),
    });
    return await res.json();
  } catch (err) {
    console.error("Error al obtener referidos:", err);
    return [];
  }
};

export const validarCheckout = async (checkout_id) => {
  try {
    const res = await fetch(`${BASE_URL}recurrente/validar-checkout/${checkout_id}`);
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error validando checkout:", error);
    return { success: false, message: "Error en validación del pago." };
  }
};

export const generarPagoTemp = async (plan, id_perfil) => {
  try {
    const res = await fetch(`${BASE_URL}pago-temp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ plan, id_perfil }),
    });

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error generando pago temporal:", error);
    return { success: false, message: "No se pudo registrar el pago temporal" };
  }
};

export const generarCheckout = async (plan, id_perfil, code) => {
  try {
    const res = await fetch(`${BASE_URL}recurrente/checkout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ plan, id_perfil, code }),
    });

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error al generar checkout:", error);
    return { success: false, message: "Error inesperado al generar el pago." };
  }
};

export const actualizarPerfil = async (datos) => {
  const response = await api.post("perfil/actualizar", datos);
  return response.data;
};

export const getNotificaciones = async (id_perfil) => {
  try {
    const res = await fetch(`${BASE_URL}notificaciones/${id_perfil}`);
    const data = await res.json();
    return data.success ? data.data : [];
  } catch (err) {
    return [];
  }
};

export async function getRetiros(id_perfil) {
  try {
    const res = await fetch(`${BASE_URL}retiros`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_perfil }),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { retiros: [] };
  }
}

export async function getCuentas(id_perfil) {
  try {
    const res = await fetch(`${BASE_URL}cuentas`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_perfil }),
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return { cuentas: [] };
  }
}

export const getBancos = async () => {
  const res = await fetch(`${BASE_URL}bancos`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return await res.json();
};

export const guardarCuenta = async ({ id_perfil, nombre, tipo, no_cuenta, banco }) => {
  const res = await fetch(`${BASE_URL}cuenta/guardar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_perfil, nombre, tipo, no_cuenta, banco }),
  });

  return await res.json();
};

export const marcarPredeterminada = async (id_perfil, id_cuenta) => {
  const res = await fetch(`${BASE_URL}cuenta/predeterminada`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_perfil, id_cuenta }),
  });
  return res.json();
};

export const eliminarCuentaBan = async (id_cuenta) => {
  const res = await fetch(`${BASE_URL}cuenta/eliminar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_cuenta }),
  });
  return res.json();
};

export const getDestinos = async () => {
  const res = await fetch(`${BASE_URL}destinos`, {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  });
  return res.json();
};

export const getEventos = async () => {
  const res = await fetch(`${BASE_URL}eventos`, {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  });
  return res.json();
};

export const getTop10Vistas = async () => {
  try {
    const res = await fetch(`${BASE_URL}comercios/top10-vistas`, {
      method: "GET"
    });
    const data = await res.json();
    if (data.success) return data.top;
    return [];
  } catch (error) {
    console.error("Error obteniendo top 10 vistas:", error);
    return [];
  }
};

export const toggleSeguirComercio = async (id_perfil, id_comercio) => {
  try {
    const response = await fetch(`${BASE_URL}seguir`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id_perfil, id_comercio })
    });

    const data = await response.json();
    return data;
  } catch (err) {
    return { success: false, message: "Error de red." };
  }
};

export const notificarme = async (id_perfil, id_categoria) => {
  try {
    const res = await fetch(`${BASE_URL}notificarme`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_perfil, id_categoria }),
    });

    return await res.json();
  } catch (error) {
    return { success: false, message: "Error de conexión." };
  }
};

export const marcarHistoriaVista = async (id_historia, id_comercio, id_usuario = null) => {
  try {
    const userAgent = navigator.userAgent;
    await axios.post(`${BASE_URL}historia/vista`, {
      id_historia,
      id_comercio,
      id_usuario,
      user_agent: userAgent
    });
  } catch (error) {
  }
};

export const verificarCorreo = async (correo) => {
  const res = await fetch(`${BASE_URL}recuperacion/verificar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ correo })
  });
  return await res.json();
};

export const obtenerIndiceRespuesta = async (id_comercio) => {
  try {
    const res = await fetch(`${BASE_URL}chat/indice-respuesta`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_comercio }) // solo el comercio
    });
    const data = await res.json();
    return data.promedio !== undefined ? data.promedio : null;
  } catch (err) {
    return null;
  }
};

export const obtenerChats = async (id_perfil) => {
  const res = await fetch(`${BASE_URL}chat/listar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_perfil })
  });

  return await res.json();
};

export const obtenerMensajes = async (id_comercio, id_sucursal, id_perfil) => {
  const res = await fetch(`${BASE_URL}mensajes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_comercio, id_sucursal, id_perfil })
  });
  return await res.json();
};

export const obtenerComercio = async (id_comercio) => {
  const res = await fetch(`${BASE_URL}comercio/${id_comercio}`);
  const data = await res.json();
  return data.success ? data.comercio : null;
};

export const enviarMensaje = async ({ id_comercio, id_sucursal, id_perfil, texto }) => {
  const res = await fetch(`${BASE_URL}enviar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_comercio, id_sucursal, id_perfil, texto })
  });
  return await res.json();
};

export const toggleFavorito = async (id_comercio, id_perfil) => {
  const res = await fetch(`${BASE_URL}favorito/toggle`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_comercio, id_perfil })
  });
  return await res.json();
};

export const registrarOpinion = async (opinion) => {
  const res = await fetch(`${BASE_URL}opinion/registrar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(opinion),
  });
  return await res.json();
};

export const obtenerComerciosMapa = async (ne = null, sw = null, categoria = null) => {
  try {
    let url = `${BASE_URL}comercios/mapa`;
    const params = [];

    if (ne && sw) {
      params.push(`neLat=${ne.lat}`, `neLng=${ne.lng}`, `swLat=${sw.lat}`, `swLng=${sw.lng}`);
    }

    if (categoria) {
      params.push(`categoria=${categoria}`);
    }

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    const res = await fetch(url);
    return await res.json();
  } catch (error) {
    return { success: false };
  }
};

export const verificarFavorito = async (id_comercio, id_perfil) => {
  const res = await fetch(`${BASE_URL}favorito/verificar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_comercio, id_perfil })
  });
  return await res.json();
};

export const enviarCodigo = async (id_perfil, method) => {
  const res = await fetch(`${BASE_URL}recuperacion`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_perfil, method })
  });
  return await res.json();
};

export const getFavoritos = async (id_perfil) => {
  const res = await fetch(`${BASE_URL}favoritos`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_perfil }),
  });
  return await res.json();
};

export const obtenerDetalleComercio = async (id_sucursal, id_perfil) => {
  const res = await fetch(`${BASE_URL}comercio/detalle`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_sucursal, id_perfil })
  });
  return await res.json();
};

export const obtenerShareLinkComercio = async (id_sucursal) => {
  const res = await fetch(`${BASE_URL}comercio/share-link`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_sucursal })
  });
  return await res.json();
};

export const validarCodigo = async (id_perfil, codigo) => {
  const res = await fetch(`${BASE_URL}recuperacion/validar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_perfil, codigo })
  });
  return await res.json();
};

export const actualizarClave = async (id_perfil, clave) => {
  const res = await fetch(`${BASE_URL}recuperacion/nueva-clave`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_perfil, clave })
  });
  return await res.json();
};

export const actualizarClavePerfil = async (id_perfil, clave_actual, clave_nueva) => {
  try {
    const res = await api.post('perfil/cambiar-clave', {
      id_perfil,
      clave_actual,
      clave_nueva
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || "Error al cambiar contraseña" };
  }
};

export const registrarUsuario = async (datos) => {
  try {
    const res = await fetch(`${BASE_URL}register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(datos)
    });
    const result = await res.json();
    return result;
  } catch (error) {
    return { success: false, error: "Error de conexión." };
  }
};

export const registrarVistaComercio = async (id_comercio, id_perfil = null, anon_id, lat = null, lang = null) => {
  try {
    const res = await fetch(`${BASE_URL}comercio/view`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id_comercio, id_perfil, anon_id, lat, lang }),
    });

    return await res.json();
  } catch (error) {
    return { success: false };
  }
};

export const recomendarDestino = async ({ id_destino, id_perfil }) => {
  const res = await fetch(`${BASE_URL}recomendar-destino`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_destino, id_perfil }),
  });
  return await res.json();
};

export const enviarReporteError = async (reporte) => {
  const res = await fetch(`${BASE_URL}reporte-error`, {
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reporte)
  });
  return await res.json();
};

export const getRuletaData = async (id_perfil) => {
  try {
    const res = await fetch(`${BASE_URL}ruleta`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_perfil }),
    });
    return await res.json();
  } catch (error) {
    return null;
  }
};

// api.js o donde tengas tus funciones de fetch
export const yaRecomendoDestino = async ({ id_destino, id_perfil }) => {
  const res = await fetch(`${BASE_URL}ya-recomendo-destino`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_destino, id_perfil }),
  });
  return await res.json();
};

//Registramos el historial en la ruleta.
export const registrarIntentoRuleta = async ({ id_perfil, id_comercio }) => {
  try {
    const res = await fetch(`${BASE_URL}intento-ruleta`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_perfil, id_comercio })
    });
    return await res.json();
  } catch (error) {
    return null;
  }
};

export const registrarAnalyticsSlider = async (id_slider, tipo, id_usuario = null) => {
  try {
    await api.post(`${BASE_URL}analytics`, {
      id_slider,
      tipo,
      id_usuario
    });
  } catch (err) {
  }
};

export const obtenerPerfil = async (id_perfil) => {
  try {
    const response = await fetch(`${BASE_URL}perfil/${id_perfil}`);
    const data = await response.json();
    return data?.data || null;
  } catch (error) {
    return null;
  }
};

export const obtenerOfertas = async () => {
  try {
    const res = await fetch(`${BASE_URL}ofertas`);
    const data = await res.json();
    return data.ofertas || [];
  } catch (err) {
    return [];
  }
};

export const obtenerContenidoSettings = async (tipo) => {
  try {
    const res = await fetch(`${BASE_URL}settings/${tipo}`);
    const data = await res.json();
    return data.success ? data.contenido : null;
  } catch (error) {
    return null;
  }
};

export const obtenerTimeline = async (id_perfil, page = 1, limit = 3) => {
  try {
    const res = await api.post(`${BASE_URL}timeline`, { id_perfil, page, limit });
    return res.data.timeline || [];
  } catch (error) {
    return [];
  }
};

export const registrarAnalyticsOferta = async (id_oferta, id_usuario = null, lat = null, lang = null) => {
  try {
    await api.post(`${BASE_URL}oferta/analytics`, {
      id_oferta,
      id_usuario,
      lat,
      lang
    });
  } catch (err) {
  }
};

export const getDetalleDestino = async (id) => {
  const res = await fetch(`${BASE_URL}destino/${id}`);
  const data = await res.json();
  return data;
};

export const getCategorias = async (page = 1, id_perfil = 0) => {
  const res = await fetch(`${BASE_URL}categorias?page=${page}&id_perfil=${id_perfil}`);
  const data = await res.json();
  return data;
};

export const getIntereses = async (id_perfil = 0) => {
  const res = await fetch(`${BASE_URL}getIntereses`);
  const data = await res.json();
  return data;
};


export const guardarIntereses = async (id_perfil, intereses) => {
  const res = await fetch(`${BASE_URL}guardar-intereses`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id_perfil, intereses }),
  });
  const data = await res.json();
  return data;
};

export const loginUsuario = async (datos) => {
  try {
    const response = await fetch(`${BASE_URL}login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(datos)
    });
    const result = await response.json();
    return result;
  } catch (error) {
    return { error: "Error de conexión." };
  }
};

export const validarCodigoReferido = async (codigo) => {
  try {
    const res = await fetch(`${BASE_URL}validar-referido`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ codigo })
    });

    return await res.json();
  } catch (error) {
    return { success: false, error: "Error de conexión." };
  }
};

export const getComerciosCercanos = async (lat, lng) => {
  try {
    const response = await api.get(`${BASE_URL}comercios-cercanos`, {
      params: { lat, lng }
    });
    return response.data;
  } catch (error) {
    return [];
  }
};

export const eliminarCuenta = async (id_perfil) => {
  try {
    const res = await fetch(`${BASE_URL}perfil/eliminar/${id_perfil}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });

    const data = await res.json();
    return data;
  } catch (error) {
    return { success: false, message: "Error al eliminar la cuenta." };
  }
};

export const buscarComercios = async (query) => {
  const res = await api.get(`${BASE_URL}buscar?q=${query}`);
  return res.data;
};

export const getSugerenciasInteres = async (id_perfil) => {
  const res = await api.get(`${BASE_URL}sugerencias-interes?id_perfil=${id_perfil}`);
  return res.data;
};

export const guardarEnHistorial = async (id_perfil, termino, id_comercio = null) => {
  const res = await api.post(`${BASE_URL}historial`, { id_perfil, termino, id_comercio });
  return res.data;
};

export const getHistorialBusqueda = async (id_perfil) => {
  const res = await api.get(`${BASE_URL}historial/${id_perfil}`);
  return res.data;
};

export const eliminarDelHistorial = async (id_busqueda) => {
  const res = await fetch(`${BASE_URL}historial/eliminar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_busqueda }),
  });
  return await res.json();
};

export const getComerciosPorCategoria = async (id_categoria, id_perfil = 0) => {
  const res = await api.get(`${BASE_URL}comercios-por-categoria/${id_categoria}`, {
    params: { id_perfil }
  });
  return res.data;
};

export const registrarTap = async (id_sucursal, tipo, id_usuario = null, id_destino = null, url = null, isView = 0) => {
  try {
    const res = await fetch(`${BASE_URL}registro-tap`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id_sucursal, tipo, id_usuario, id_destino, url, isView })
    });
    return await res.json();
  } catch (err) {
    return { success: false };
  }
};

export const registrarTapConDistancia = async (id_sucursal, tipo, distancia, id_usuario = null) => {
  try {
    const res = await fetch(`${BASE_URL}registro-tap`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id_sucursal,
        tipo,
        distancia,
        id_usuario
      })
    });
    return await res.json();
  } catch (error) {
    return { success: false };
  }
};

export const registrarComercioNoEncontrado = async (termino) => {
  try {
    const res = await fetch(`${BASE_URL}comercio/no-encontrado`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ termino }),
    });

    const data = await res.json();
    return data;
  } catch (error) {
    return { success: false };
  }
};

export const registrarUsuarioAnonimo = async (anon_id) => {
  try {
    const os = localStorage.getItem("os_device") || "Desconocido";
    const user_agent = navigator.userAgent;
    const ip = "";

    await fetch(`${BASE_URL}usuario/anonimo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ anon_id, os_device: os, user_agent, ip }),
    });
  } catch (err) {
  }
};

export async function guardarUbicacionHistorial(lat, lng, id_perfil = null) {
  const anon_id = localStorage.getItem("anon_id");

  try {
    const res = await fetch(`${BASE_URL}historial-ubi`, {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        latitud: lat,
        longitud: lng,
        id_perfil,
        anon_id
      })
    });

    return await res.json();
  } catch (err) {
    return null;
  }
}

export const registrarAlcanceOferta = async (id_oferta, userId = null, lat = null, lang = null) => {
  const sessionHash = localStorage.getItem('anon_id') || 'sin_hash';
  const user_agent = navigator.userAgent;

  try {
    const res = await fetch(`${BASE_URL}ofertas/registrar-alcance`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id_oferta,
        id_usuario: userId,
        user_agent,
        session_hash: sessionHash,
        lat,
        lang
      }),
    });

    const data = await res.json();
    return data;
  } catch (err) {
  }
};

export const registrarAlcanceTimeline = async (id_wall, id_usuario = null, lat = null, lang = null) => {
  try {
    await api.post(`${BASE_URL}timeline/alcance`, {
      id_wall,
      id_usuario,
      lat,
      lang
    });
  } catch (err) {
  }
};

export const registrarVistaTimeline = async (id_wall, id_usuario = null, lat = null, lang = null) => {
  try {
    await api.post(`${BASE_URL}timeline/analytics`, {
      id_wall,
      id_usuario,
      lat,
      lang
    });
  } catch (err) {
  }
};

export const registrarTrafico = async (vista, lat = null, lang = null) => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData") || "null");

    await fetch(`${BASE_URL}registrar-trafico`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_usuario: userData?.id || null,
        vista,
        lat, 
        lang
      }),
    });
  } catch (err) {
  }
};

export const obtenerDetalleEvento = async (id_evento, id_perfil = null) => {
  const res = await fetch(`${BASE_URL}evento/detalle/${id_evento}/${id_perfil}`);
  return await res.json();
};

export const registrarAsistencia = async (id_evento, id_perfil) => {
  const res = await fetch(`${BASE_URL}evento/asistir`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_evento, id_perfil })
  });
  return await res.json();
};

export default api;
